import React, { Component } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Translation, withTranslation } from "react-i18next";
import { withRouter } from "react-router";
import { toast } from "react-toastify";
import {
  addUsedCarBought,
  getPersonList,
  getCarSellQuery,
  getLocation
} from "../../constants/apiParams";
import apiCall, { METHOD } from "../../constants/baseUrl";
import { getUserID, months, ToTimeStamp } from "../../util/utils";

class BoughtUsedCar extends Component {
  constructor(props) {
    super(props);
    if (props.sale) {

    }

    this.state = {
      isLoading: false,
      selectedSalesPerson: 0,
      personList: [],
      locationList: [],
      selectedBoughtDate: new Date(),
      selectedLocation: 0,
      customer: "",
      carSellLoaded: false,
    };
  }

  componentDidMount() {
    if (this.props.sellId) this.getCarSellData();
    this.getLocationList();
  }

  getCarSellData = () => {

    apiCall(
      METHOD.QUERY,
      getCarSellQuery(this.props.sellId),
      (data) => this.handleCarSellResponse(data.car_sell),
      (isLoading) => this.handleLoader(isLoading),
      (data) => {
        toast.error(this.props.t(data.message));
      }
    );
  };

  getLocationList = () => {
    apiCall(
      METHOD.QUERY,
      getLocation(getUserID(), 0, 0),
      (data) => this.handleLocationListResponse(data),
      (isLoading) => this.handleLoader(isLoading),
      (data) => {
        toast.error(this.props.t(data.message));
      }
    );
  };
  handleLocationListResponse = (data) => {
    this.setState({
      locationList: data.location_list,
    });
  };

  getPersonList = (locationId) => {
    apiCall(
      METHOD.QUERY,
      getPersonList(getUserID(), 0, 0, parseInt(locationId)),
      (data) => this.handlePersonListResponse(data),
      (isLoading) => this.handleLoader(isLoading),
      (data) => {
        toast.error(this.props.t(data.message));
      }
    );
  };
  handlePersonListResponse = (data) => {
    const personList = data.sales_person_list;
    personList.sort((a,b) => a.surname.localeCompare(b.surname));

    this.setState({
      personList: personList,
    });
  };

  handleCarSellResponse = (data) => {
    this.setState({
      selectedSalesPerson: data.sales_person_id,
      selectedBoughtDate: this.parseDate(data.sales_date),
      selectedInsurance: JSON.parse(data.insurance_id),
      insurance: JSON.parse(data.insurance_id) === null ? false : true,
      customer: data.customer,
      selectedCarBrand: data.car_brand_id,
      selectedCarBroker: data.car_broker_id,
      carSellLoaded: true
    });
  };

  handleLoader = (isLoading) => {
    this.setState({
      isLoading,
    });
  };
  parseDate = (input) => {
    var parts = input.match(/(\d+)/g);
    // note parts[1]-1
    return new Date(parts[2], parts[1]-1, parts[0]);
  };

  handleLocationChange = (locationId) => {
    if(locationId === 0 || locationId === "0") return;
    this.getPersonList(locationId);
    this.setState({
      selectedLocation: parseInt(locationId)
    });
  }

  generateTimeStamp = (_date) => {
    const monthNumber = _date.getMonth();
    const _year = _date.getFullYear();
    const _hour = _date.getHours();
    const _minutes = _date.getMinutes();
    const _seconds = _date.getSeconds();
    var date = _date.getDate();
    var month = months[monthNumber];
    var year = _year;
    var hours = _hour;
    if (hours <= 2 ){
      hours = 12; //the middle of the day, to avoid timezone-problems
    }
    var minutes = _minutes;
    var seconds = _seconds;

    var shortDateTime =
      month +
      " " +
      date +
      " " +
      year +
      " " +
      hours +
      ":" +
      minutes +
      ":" +
      seconds;

    return ToTimeStamp(shortDateTime);
  };
  handleSubmit = () => {
    const {
      selectedSalesPerson,
      selectedBoughtDate,
      selectedLocation,
      customer,
    } = this.state;
    if (!customer) {
      toast.warn(this.props.t("BoughtUsedCar.customerValidation"));
    } else if (parseInt(selectedSalesPerson) === 0) {
      toast.warn(this.props.t("BoughtUsedCar.personSelectValidation"));
    } else if (parseInt(selectedLocation) === 0) {
      toast.warn(this.props.t("BoughtUsedCar.locationSelectValidation"));
    } else {
      let timeStamp;
      if (selectedBoughtDate) {
        timeStamp = this.generateTimeStamp(selectedBoughtDate);
      } else {
        timeStamp = 0;
      }
      apiCall(
        METHOD.QUERY,
        addUsedCarBought(
          this.props.sellId,
          getUserID(),
          customer,
          selectedSalesPerson,
          timeStamp,
        ),
        (data) => this.handleCreateSalesCarResponse(data),
        (isLoading) => {
          this.setState({ createIsLoading: isLoading });
        },
        (data) => {
          toast.error(this.props.t(data.message));
        }
      );
    }
  };

  handleCreateSalesCarResponse = (data) => {
    toast.success(this.props.t(data.message));
    this.props.handleNewCarBoughtModal(false);
  };

  render() {
    const {
      isLoading,
      createIsLoading,
      selectedLocation,
      selectedSalesPerson,
      personList,
      selectedBoughtDate,
      customer,
      locationList,
    } = this.state;
    const { handleNewCarBoughtModal } = this.props;

    if (this.props.sellId && !this.state.carSellLoaded) return <></>;

    return (
      <Translation ns="translation">
        {(t, { i18n }) => {
          return (
            <div className="d-block">
              <div
                className="modal d-block"
                id="exampleModal"
                tabIndex="-1"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="exampleModalLabel">
                        {t("BoughtUsedCar.lblNewUsedCar")}
                      </h5>
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                        onClick={() => {
                          handleNewCarBoughtModal(false);
                        }}
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      {isLoading && (
                        <div className="loader-container">
                          <div className="loader-logo">
                            <div className="sk-chase">
                              <div className="sk-chase-dot"></div>
                              <div className="sk-chase-dot"></div>
                              <div className="sk-chase-dot"></div>
                              <div className="sk-chase-dot"></div>
                              <div className="sk-chase-dot"></div>
                              <div className="sk-chase-dot"></div>
                            </div>
                          </div>
                        </div>
                      )}
                      <div className="row">
                        <div className="col-md-12">
                          <div className="form-group">
                            <label> {t("BoughtUsedCar.boughtDate")}</label>
                            <br />
                            <DatePicker
                              selected={selectedBoughtDate}
                              locale={localStorage.getItem('i18nextLng') ?? 'de'}
                              className="form-control"
                              popperPlacement="bottom-end"
                              onChange={(date) => {
                                this.setState({
                                  selectedBoughtDate: date,
                                });
                              }}
                              dateFormat="d.MM.yyyy"
                            />
                          </div>

                          <div className="form-group">
                            <label>
                              {t("managePersonList.locationPlaceHolder")}
                            </label>
                            <select
                              className="custom-select"
                              onChange={(e) => {
                                return this.handleLocationChange(e.target.value);
                              }}
                              onMouseUp={(e) => {
                                return this.handleLocationChange(e.target.value);
                              }}
                              value={JSON.parse(JSON.stringify(selectedLocation))}
                            >
                              <option value={0}>
                                {t("managePersonList.locationSelection")}
                              </option>
                              {locationList &&
                                locationList.map((item, index) => {
                                  const { name, id } = item;
                                  return (
                                    <option
                                      key={index}
                                      value={id}
                                    >
                                      {name && name}
                                    </option>
                                  );
                                })}
                            </select>
                          </div>

                          <div className="form-group">
                            <label> {t("BoughtUsedCar.salesPerson")}</label>
                            <select
                              className="custom-select"
                              onMouseUp={(e) => {
                                this.setState({
                                  selectedSalesPerson: e.target.value,
                                });
                              }}
                              onChange={(e) => {
                                this.setState({
                                  selectedSalesPerson: e.target.value,
                                });
                              }}
                              value={selectedSalesPerson}
                              disabled={!parseInt(selectedLocation)}
                            >
                              <option value="0">
                                {t("BoughtUsedCar.selectSalesPerson")}
                              </option>
                              {personList &&
                                personList.map((item, index) => {
                                  return (
                                    <option
                                      key={index}
                                      value={item.id}
                                    >
                                      {item.surname}, {item.firstname}
                                    </option>
                                  );
                                })}
                            </select>
                          </div>

                          <div className="form-group">
                            <label>{t("BoughtUsedCar.customer")}</label>
                            <input
                              type="text"
                              value={customer}
                              onChange={(e) => {
                                this.setState({
                                  customer: e.target.value,
                                });
                              }}
                              className="form-control"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="modal-footer">
                      <button
                        className="btn btn-secondary width-100p mr-2"
                        onClick={() => {
                          this.props.handleNewCarBoughtModal(false);
                        }}
                      >
                        {t("BoughtUsedCar.cancel")}
                      </button>

                      {createIsLoading ? (
                        <button className="btn btn-primary width-100p mr-2">
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          {t("BoughtUsedCar.submit")}
                        </button>
                      ) : (
                        <button
                          className="btn btn-primary width-100p "
                          disabled={isLoading}
                          onClick={() => {
                            this.handleSubmit();
                          }}
                        >
                          {t("BoughtUsedCar.submit")}
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-backdrop fade show"></div>
            </div>
          );
        }}
      </Translation>
    );
  }
}
export default withRouter(withTranslation()(BoughtUsedCar));
